import { JsonObject, JsonProperty } from "json2typescript"

@JsonObject("OpeningHours")
export class OpeningHours {
  @JsonProperty('from', String)
  from: string = ''
  @JsonProperty('hours', String)
  hours: string = ''
}
